import React from 'react';

const CourseStudentFormModal = React.lazy(() => import('../components/FormModal'));
const courseStudentModalRegistry = {
    community_courseStudentId: CourseStudentFormModal
};
export default courseStudentModalRegistry;
